import { createAction } from '@reduxjs/toolkit'
import { ConvertToken, CurrentConvertInfo } from './reducer'

export const updateBaseToken = createAction<ConvertToken>(
  'convert/updateBaseToken',
)
export const updateQuoteToken = createAction<ConvertToken>(
  'convert/updateQuoteToken',
)
export const updateCurrentConvertInfo = createAction<CurrentConvertInfo>(
  'convert/updateCurrentConvertInfo',
)
export const resertConvertState = createAction('convert/resertState')
export const updateSwapDisabled = createAction<boolean>(
  'convert/updateSwapDisabled',
)
